import { get } from "lodash";

const styles = (theme) => ({
  alertMessagesContainer: {
    marginLeft: 0,
    width: "93% !important",
  },
  content: {
    margin: 36,
    minHeight: 'calc(100vh - 125px)',
    backgroundColor: get(theme, 'color.uiBackground'),
    marginTop: 0,
    padding: '24px 0px 36px 0px',
  },
  contentPadding: {
    padding: '0px 36px',
  },
  deleteButton: {
    color: get(theme, 'color.error'),
    borderColor: get(theme, 'color.error'),
  },
  editIconButton: {
    fill: get(theme, 'color.primaryButtonBackground'),
    minWidth: 0,
    width: 35,
    height: 35,
    padding: 0,
    marginLeft: "1rem",
    marginTop: "1rem",
  },
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerNameContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  linkContainer: {
    fontSize: '10px !important',
    fontFamily: get(theme, 'typogaphy.pageTitle'),
  },
});

export default styles;
